import script from "./IntroPage.vue?vue&type=script&setup=true&lang=js"
export * from "./IntroPage.vue?vue&type=script&setup=true&lang=js"

import "./IntroPage.vue?vue&type=style&index=0&id=90d8e570&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90d8e570"]])

export default __exports__